// The wind shared by the hero's landscape trees (HeroLandscape.vue) and the
// foreground grass (HeroGrassFringe.vue), so a gust visibly travels through
// the whole scene: it enters on the left, crosses the hero in TRAVEL seconds
// and every plant leans, rebounds and settles as the front passes over it.
//
// Both components keep their own simulation clock from the moment they mount
// (they mount together and pause together), so they read the same wind for
// the same time. Everything is a pure function of time, which keeps
// renderAt() exact.

import { seededRandom } from './heroMotion';

const TRAVEL = 2.6;   // s for a gust front to cross the hero, left to right
const LENGTH = 5.5;   // s a gust keeps a plant moving after the front reaches it
const gusts = [];
let cycle = 0;

(function planGusts() {
  const random = seededRandom(7741);
  // The first gust arrives once the entrance has settled.
  let t = 6.5;
  for (let i = 0; i < 48; i++) {
    gusts.push({ at: t, strength: 0.55 + random() * 0.45 });
    t += 8 + random() * 9;
  }
  cycle = t;
})();

// A lean that builds up quickly, rebounds a little past rest and dies out
// (peak 1 at ~0.7 s, rebound ~-0.24 at ~2.5 s).
function profile(tau) {
  if (tau <= 0 || tau >= LENGTH) return 0;
  const fadeOut = tau > LENGTH - 1 ? 1 - (tau - (LENGTH - 1)) : 1;
  return 1.84 * Math.exp(-tau / 1.3) * Math.sin(1.7 * tau) * fadeOut;
}

// The gusts blowing at time t (seconds). at(u) gives the lean at a horizontal
// position u (0 = left edge of the hero, 1 = right edge): positive leans to
// the right, mostly within -0.25..1.
export function gustField(t) {
  const tw = ((t % cycle) + cycle) % cycle;
  const active = [];
  for (let i = 0; i < gusts.length; i++) {
    const g = gusts[i];
    if (g.at <= tw && g.at >= tw - LENGTH - TRAVEL) active.push(g.at, g.strength);
    // Gusts from the end of the previous cycle can still be blowing.
    const prev = g.at - cycle;
    if (prev <= tw && prev >= tw - LENGTH - TRAVEL) active.push(prev, g.strength);
  }
  return {
    at(u) {
      let v = 0;
      for (let i = 0; i < active.length; i += 2) {
        v += profile(tw - active[i] - u * TRAVEL) * active[i + 1];
      }
      return v;
    }
  };
}

// The slowly varying strength of the everyday breeze, 0.6..1.
export function breezeAt(t) {
  return 0.8 + 0.14 * Math.sin((t * 2 * Math.PI) / 23) + 0.06 * Math.sin((t * 2 * Math.PI) / 9.3);
}
